// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"3389b283","508":"5f0cedba","787":"996d91c3"}[chunkId] + ".chunk.js";
};